import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUser, FiMapPin, FiBriefcase, FiCreditCard, FiCheck } = FiIcons;

function ProgressBar({ currentStep, totalSteps }) {
  const steps = [
    { icon: FiUser, label: 'Personal' },
    { icon: FiMapPin, label: 'Contact' },
    { icon: FiBriefcase, label: 'Employment' },
    { icon: FiCreditCard, label: 'Account' },
  ];

  return (
    <div className="w-full max-w-full overflow-x-hidden">
      <div className="flex items-center justify-between mb-4 min-w-0 w-full">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div key={index} className="flex flex-col items-center flex-1 min-w-0 px-1 max-w-full">
              {/* Step Circle */}
              <motion.div
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                className={`w-8 h-8 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mb-2 transition-all duration-300 flex-shrink-0 ${
                  isCompleted
                    ? 'bg-agric-primary text-white'
                    : isCurrent
                    ? 'bg-agric-primary text-white ring-2 sm:ring-4 ring-agric-primary/20'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {isCompleted ? (
                  <SafeIcon icon={FiCheck} className="w-3 h-3 sm:w-6 sm:h-6" />
                ) : (
                  <SafeIcon icon={step.icon} className="w-3 h-3 sm:w-6 sm:h-6" />
                )}
              </motion.div>

              {/* Step Label */}
              <span className={`text-xs sm:text-sm font-medium text-center truncate w-full max-w-full ${
                isCompleted || isCurrent ? 'text-agric-primary' : 'text-gray-500'
              }`}>
                {step.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-2 max-w-full">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${(currentStep / totalSteps) * 100}%` }}
          transition={{ duration: 0.5 }}
          className="bg-agric-primary h-2 rounded-full max-w-full"
        />
      </div>
    </div>
  );
}

export default ProgressBar;